import { Config } from "../config/Config";
import { firestore } from "../utilities/Firebase";

/**
 * 店舗サービス
 */
export const ShopService = () => {
  /**
   * Firestore から店舗データを取得
   * @param campaignId キャンペーンID
   * @param shopId 店舗ID
   */
  const getShop = async (campaignId: string, shopId: string) => {
    const path = `${Config.appEnv}/${campaignId}/Shops`;
    const doc = await firestore.collection(path).doc(shopId).get();
    const data = doc.data();

    if (!data) {
      throw new Error(`Shop is not found. shopId: ${shopId}`);
    }

    return { id: doc.id, data };
  };

  /**
   * Firestore から店舗一覧を取得
   * @param campaignId キャンペーンID
   */
  const getShopList = async (campaignId: string) => {
    const path = `${Config.appEnv}/${campaignId}/Shops`;
    const ref = firestore.collection(path);
    const snapshot = await ref.get();

    const shopList = snapshot.docs
      .map((doc) => {
        return { id: doc.id, data: doc.data() };
      })
      .filter((shop) => !shop.data["closed"]);

    return shopList;
  };

  return { getShop, getShopList };
};
